<template>
    <div class='app'>
        <el-main>
            <div class="top-wrap">
                <Bread></Bread>
            </div>
            <div class="main">
                <div class="plate">
                    <div class="title">供应商信息</div>
                </div>
                <div class="center_true">
                    <div class="box">
                        <img src="../../../assets/szoperative/tijiao_ok_img@2x.png" alt="">
                        <div class="tj">添加成功</div>
                        <div>
                            <el-button @click="$router.push({path:'./List'})">查看供应商列表</el-button>
                            <el-button type="primary" @click="$router.push({path:'./Add'})">继续添加</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-main>
    </div>
</template>

<script>
export default {
    components: {},
    props: [],
    data() {
        return {};
    },
    mounted() { },
    created() { },
    methods: {},
};
</script>

<style lang='scss' scoped>
.plate {

    .title {
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        font-weight: bold;

        label {
            font-size: 16px;
            color: #999999;
        }

        &:before {
            content: "";
            display: inline-block;
            width: 5px;
            height: 18px;
            background: #018388;
            border-radius: 3px;
            margin-right: 5px;
        }
    }
}

.center_true {
    width: 100%;
    height: 100%;
    // height: calc(100vh - 72px) !important;

    text-align: center;

    img {
        width: 108px;
        height: 108px;
        margin-top: 10vh;
    }

    .box {
        width: 100%;
        height: 100%;


    }

    .tj {
        // width: 103px;
        height: 27px;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 41px;
        margin-top: 29px;
        margin-bottom: 50px;
    }

    .el-button {
        width: 180px;
        height: 60px;
        margin-bottom: 100px;
    }
}

.layout .el-container .el-main .main {
    z-index: 0;
    // height: calc(100vh - 72px) !important;
    // background-color: red;
    // height: calc(100vh - 72px - 56px - 16px - 70px) !important;

}
</style>
